import { __ } from './../locale';
const configIni = require('./../conf.json');

const {
  authUrl,
  merchantUrl,
  ga, // should be deprecated in july when ga is deprecated
  ga4,
  lastMinuteGa, // should be deprecated in july when ga is deprecated
  lastMinuteGa4,
  googleOptimize,
  hotjar,
  sentry,
  adyenClientKey,
  adyenCheckoutClientKey,
  giftcardAdyenClientKey,
  googlepay,
  applepay,
  amplitudeAnalytics,
  amplitudeAnalyticsSistaminuten,
  amplitudeAnalyticsSaas,
  amplitudeExperiment,
  amplitudeExperimentSistaminuten,
  cookieDomain,
  cypressProjectId,
  turnstileSiteKey,
  mapTiler,
  basicAuth,
  confidenceClientKey,
} = configIni || {};

/***** APP CONFIGURATION ENVIRONMENT VARIABLES *********************************/
// `process` is a Node.js global — not available in the browser (webpack 5 removed the polyfill).
// Use typeof guard so this file works in both SSR (Node.js) and browser contexts.
const _serverEnv = typeof process !== 'undefined' ? process?.env || {} : {};
const _win = typeof window !== 'undefined' ? window : {};

const _rawEnvName = _serverEnv.envName || _win._ENV_NAME || 'local';
const envName = ['local', 'bddev', 'stage', 'smoke', 'prod'].includes(_rawEnvName) ? _rawEnvName : 'local'; // values: local | bddev | stage | smoke | prod
const _rawBuildENV = _serverEnv.env || undefined;
const buildENV = _rawBuildENV === 'production' ? 'production' : _rawBuildENV ? 'development' : _win._ENV || undefined; // values: development | production
const DOMAIN = _serverEnv.DOMAIN_NAME || undefined;
// Base — on the server DOMAIN_NAME drives the URLs; in the browser the SSR injects window._BASE_URL / window._SERVER_URL
const BASE_URL = DOMAIN ? 'https://' + DOMAIN + '/' : _win._BASE_URL || undefined;
// const SERVER_URL = 'https://www.bddev.se/api';
const SERVER_URL = BASE_URL ? BASE_URL + 'api/' : _win._SERVER_URL || undefined;

/***** APP CONFIGURATION ENVIRONMENT VARIABLES *********************************/

const getConfidenceEnvironment = () => {
  switch (envName) {
    case 'smoke':
      return 'production-smoke';
    case 'prod':
      return 'production';
    default:
      return 'development';
  }
};

export const config = {
  basicAuth: {
    username: basicAuth?.username || 'admin',
    password: basicAuth?.password || 'boka123',
  },
  weekDaysShort: [__('sun'), __('mon'), __('tue'), __('wed'), __('thu'), __('fri'), __('sat')],
  weekDaysLong: [
    __('sunday'),
    __('monday'),
    __('tuesday'),
    __('wednesday'),
    __('thursday'),
    __('friday'),
    __('saturday'),
  ],
  monthsShort: [
    __('jan'),
    __('feb'),
    __('mar'),
    __('apr'),
    __('may'),
    __('jun'),
    __('jul'),
    __('aug'),
    __('sep'),
    __('oct'),
    __('nov'),
    __('dec'),
  ],
  monthsLong: [
    __('january'),
    __('february'),
    __('march'),
    __('april'),
    __('may'),
    __('june'),
    __('july'),
    __('august'),
    __('september'),
    __('october'),
    __('november'),
    __('december'),
  ],
  baseUrl: BASE_URL || 'http://localhost:3000/',
  serverUrl: SERVER_URL || 'http://localhost:3001/',
  authUrl: authUrl || 'https://konto.bddev.se/',
  merchantUrl: merchantUrl || 'https://kund.bddev.se',
  landingPath: 'places',
  portalPath: 'portal',
  confidenceEnv: getConfidenceEnvironment(),
  ga: ga || 'UA-483672-46', // 46 - dev
  ga4: ga4 || 'G-ZBEXHZ05FG', // G-ZBEXHZ05FG - dev, G-JREQRCMRGN - prod
  lastMinuteGa: lastMinuteGa || 'UA-483672-46', // 46 - dev
  lastMinuteGa4: lastMinuteGa4 || 'G-ZBEXHZ05FG', // G-ZBEXHZ05FG - dev, G-P7T09R7674 - prod
  googleOptimize: googleOptimize || 'OPT-T488TCX', // OPT-T488TCX is dev
  facebookPixel: '847860578602702',
  lastMinuteFacebookPixel: '638678019649214',
  tikTokPixel: 'CKF7C0JC77U1O76TD4IG',
  lastMinuteTikTokPixel: 'CKIHVPRC77UANPJ93FN0',
  hotjar: hotjar || '1014658', // !!!! 1014658 is dev, 1014642 is live
  env: buildENV || 'development', // values: development | production
  envName: envName || 'local', // values: local | bddev | stage | smoke | prod
  sentry: sentry || undefined,
  adyenClientKey,
  adyenCheckoutClientKey,
  giftcardAdyenClientKey: giftcardAdyenClientKey || 'test_SK3SZVZCXVC7ZBWRX5DK6CWUAIPJHEUH',
  adyen: {
    clientKey: adyenCheckoutClientKey || 'test_2S2KMEC3UZEPLO3ORKMXP4W6VAUBPJOC',
    locale: 'sv-SE',
    currency: 'SEK',
    countryCode: 'SE',
  },
  googlepay,
  applepay,
  amplitudeAnalytics,
  amplitudeAnalyticsSistaminuten,
  amplitudeAnalyticsSaas: amplitudeAnalyticsSaas || '6a267ef7be3a1f08057f1c1ca10d1618',
  amplitudeExperiment,
  amplitudeExperimentSistaminuten,
  customerIOSiteId: buildENV === 'development' ? 'f3de5ab6c43fd01f53fd' : '9c01c579520fa1afb7d9', // live or sandbox siteId
  cookieDomain,
  sistaMinutenCookieDomain: cookieDomain, // deprecated - TODO: remove sistaMinutenCookieDomain from code
  cypressProjectId,
  turnstileSiteKey,
  mapTiler: {
    mapId: mapTiler?.mapId || '0195b2aa-8153-7c42-8641-f3f02c490ff2',
    apiKey: mapTiler?.apiKey || 'J2h8NzWlACc18q5mHZwl',
  },
  confidenceClientKey: confidenceClientKey || 'JLTCCShTAKbz3AgNRuq72dhUZ2wNM6pZ',
};
